import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Auto-reload on chunk load failure (happens when a new build is deployed
// and the browser still holds references to old content-hashed chunk filenames).
window.addEventListener('error', (event) => {
  if (event?.message?.includes('ChunkLoadError') || event?.message?.includes('Loading chunk')) {
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);